// extracted by mini-css-extract-plugin
module.exports = {"formControl":"FormsControls_formControl__1yfNv","error":"FormsControls_error__lTdZQ","input":"FormsControls_input__2zwK8","select":"FormsControls_select__3XMRM"};